import React from 'react';
import { Button, Card, Box, CardHeader, Avatar, Chip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';

const WhatsAppCommunity = ({ header = false }) => {
    const communityLink = "https://chat.whatsapp.com/DxBhVS8R4Y6EBpLr7hVw8M";

    const handleJoin = () => {
        window.open(communityLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <React.Fragment>
            {header ? (
                 <Chip
                    icon={<WhatsApp  />}
                    label="Community"
                    color="success"
                    variant="outlined"
                    sx={{ textTransform: 'none', display: { sm: 'none' } }}
                    onClick={handleJoin}
                />
            ) : (
                <Card
                    elevation={0}
                >
                    <CardHeader
                        title="Connect with us on WhatsApp"
                        subheader=" For regular updates"
                        avatar={<Avatar variant="rounded" sx={{ bgcolor: '#25D366' }}><WhatsApp /></Avatar>}
                        sx={{pb: 0}}
                    />

                    <Box sx={{ p: 2 }}>
                        {/* CTA Button */}
                        <Button
                            variant="outlined"
                            fullWidth
                            color="success"
                            sx={{ textTransform: 'none' }}
                            onClick={handleJoin}
                        >
                            Join Now
                        </Button>
                    </Box>
                </Card>
            )}
        </React.Fragment>
    );
};

export default WhatsAppCommunity;